/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    MediaFileMini,
    MediaFileMiniFromJSON,
    MediaFileMiniFromJSONTyped,
    MediaFileMiniToJSON,
} from './';

/**
 * 
 * @export
 * @interface MediaFileBundleMini
 */
export interface MediaFileBundleMini {
    /**
     * 
     * @type {number}
     * @memberof MediaFileBundleMini
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof MediaFileBundleMini
     */
    asset: number;
    /**
     * 
     * @type {string}
     * @memberof MediaFileBundleMini
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof MediaFileBundleMini
     */
    location: number;
    /**
     * 
     * @type {MediaFileMini}
     * @memberof MediaFileBundleMini
     */
    mainfile: MediaFileMini;
}

export function MediaFileBundleMiniFromJSON(json: any): MediaFileBundleMini {
    return MediaFileBundleMiniFromJSONTyped(json, false);
}

export function MediaFileBundleMiniFromJSONTyped(json: any, ignoreDiscriminator: boolean): MediaFileBundleMini {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'asset': json['asset'],
        'name': json['name'],
        'location': json['location'],
        'mainfile': MediaFileMiniFromJSON(json['mainfile']),
    };
}

export function MediaFileBundleMiniToJSON(value?: MediaFileBundleMini | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'asset': value.asset,
        'name': value.name,
        'location': value.location,
        'mainfile': MediaFileMiniToJSON(value.mainfile),
    };
}


